import { z } from "zod";

const nullableString = z.string().nullable().optional();

const auditLogWireSchema = z
	.object({
		Action: nullableString,
		EntityType: nullableString,
		EntityId: nullableString,
		EntityDisplay: nullableString,
		FieldName: nullableString,
		UserId: nullableString,
		Date: nullableString,
		action: nullableString,
		entityType: nullableString,
		entityId: nullableString,
		entityDisplay: nullableString,
		fieldName: nullableString,
		userId: nullableString,
		date: nullableString,
	})
	.passthrough();

export interface AuditLogMessage {
	action: string | null;
	entityType: string | null;
	entityId: string | null;
	entityDisplay: string | null;
	fieldName: string | null;
	userId: string | null;
	date: string | null;
}

export function parseAuditLogMessage(input: string): AuditLogMessage | null {
	let json: unknown;
	try {
		json = JSON.parse(input);
	} catch {
		return null;
	}

	const parsed = auditLogWireSchema.safeParse(json);
	if (!parsed.success) return null;

	const value = parsed.data;
	return {
		action: value.action ?? value.Action ?? null,
		entityType: value.entityType ?? value.EntityType ?? null,
		entityId: value.entityId ?? value.EntityId ?? null,
		entityDisplay: value.entityDisplay ?? value.EntityDisplay ?? null,
		fieldName: value.fieldName ?? value.FieldName ?? null,
		userId: value.userId ?? value.UserId ?? null,
		date: value.date ?? value.Date ?? null,
	};
}
